import { Separator } from "@/shared/components/ui/separator";

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/shared/components/ui/breadcrumb";
import UploadCreditCardPopover from "@/features/dashboard/pages/setting/pages/plans-and-billings/components/upload-credit/upload-credit-card-popover";
import { Link } from "react-router-dom";
import LogoSymbol from "@/shared/components/logo/logo-symbol";
import UserDropdown from "@/shared/components/user-dropdown/user-dropdown";

export default function PageHeader({ breadcrumbs }: { breadcrumbs: string[] }) {
  return (
    <header
      className={`w-full px-2 justify-between items-center rounded-t-xl top-0 flex shrink-0 gap-2 border-b bg-background py-4 h-[50px]`}
    >
      {/* LEFT: Logo + Breadcrumbs */}
      <div className="max-w-max flex items-center">
        <Link className="cursor-pointer" to="/">
          <LogoSymbol width={14} height={18} />
        </Link>

        <Separator orientation="vertical" className="mx-2 h-4" />

        <Breadcrumb>
          <BreadcrumbList>
            {breadcrumbs.map((item, index) => (
              <div key={index} className="flex items-center">
                <BreadcrumbItem>
                  <BreadcrumbPage className="text-foreground">
                    {item}
                  </BreadcrumbPage>
                </BreadcrumbItem>

                {index < breadcrumbs.length - 1 && (
                  <BreadcrumbSeparator className="hidden md:block" />
                )}
              </div>
            ))}
          </BreadcrumbList>
        </Breadcrumb>
      </div>

      {/* RIGHT: Always visible */}
      <div className="flex items-center gap-2">
        <UploadCreditCardPopover />
        <UserDropdown />
      </div>
    </header>
  );
}
